import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  private authService!: AuthService;

  constructor(private injector: Injector) {}

  private getAuthService(): AuthService {
    if (!this.authService) {
      this.authService = this.injector.get(AuthService);
    }
    return this.authService;
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isSignin = req.url.includes('/v1/auth/signin');
    const isAuthenticatedRequest = req.headers.has('Authorization');

    // Do not send a token that the browser already knows is expired. Completing
    // silently prevents feature-level error handlers from leaving an error over
    // the login screen.
    if (!isSignin && isAuthenticatedRequest) {
      const authService = this.getAuthService();
      if (authService.hasStoredToken() && !authService.isLoggedIn()) {
        authService.expireSession();
        return EMPTY;
      }
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse && error.status === 401 && !isSignin) {
          const authService = this.getAuthService();
          // A 401 only represents an expired authenticated session when a token
          // is actually present. Other 401 responses must reach their caller.
          if (authService.hasStoredToken()) {
            authService.expireSession();
            return EMPTY;
          }
        }

        return throwError(() => error);
      }),
    );
  }
}
